import type React from 'react'

/**
 * Shared pointer-down for tray thumbnails (photos, ClikArt): measures the card, swallows the
 * event so the tray doesn't start a scroll/selection, and hands the gesture to the placement
 * provider's `beginPointerDrag`. Returns false when there is nothing to drag (zero-sized card).
 */
export function startTrayDragFromPointer(
  e: React.PointerEvent<HTMLDivElement>,
  card: HTMLDivElement,
  begin: (
    clientX: number,
    clientY: number,
    rect: DOMRect,
    pointerId: number,
    pointerType: string,
    captureEl: HTMLElement
  ) => void
): boolean {
  const rect = card.getBoundingClientRect()

  if (rect.width <= 0 || rect.height <= 0) return false

  e.preventDefault()
  e.stopPropagation()
  begin(e.clientX, e.clientY, rect, e.pointerId, e.pointerType, e.currentTarget)

  return true
}
